module.exports = __webpack_public_path__ + "media/images/redesign-images/home/collegiate-logos/marquette-university-2209fd1c5e7bbd3b8b47a0618a4f3c29.svg";